import {routePlanService} from "@/service/routePlan.service";
import {Spinner} from "@nextui-org/react";
import clsx from "clsx";
import Image from "next/image";
import {useEffect, useRef, useState} from "react";
type StepItem = {
  label: string;
  icon: string;
  status: number; // 0 = pending, 1 = processing, 2 = completed, etc.
};
// data={{changeVariant, newAddedVariantId,setIsHistoryTab}}
const stepsAddOnly: StepItem[] = [
  {label: "Data initialized ", icon: "user", status: 2},
  {label: "Validating boarding point", icon: "dataAnalyis", status: 1},
  {label: "Processing boarding point", icon: "routedull", status: 0},
  {label: "Done", icon: "vehicledull", status: 0}
];

const stepsCreateVariant: StepItem[] = [
  {
    label: "Analyzing Student Data",
    icon: "dataAnalyis",
    status: 2
  },
  {
    label: "Clustering Users",
    icon: "user",
    status: 1
  },
  {
    label: "Assigning Vehicles",
    icon: "vehicledull",
    status: 0
  },
  {
    label: "Finalizing Routes",
    icon: "routedull",
    status: 0
  }
];
export const ProcessingPopup = ({
  changeVariant,
  newAddedVariantId,
  setIsHistoryTab,
  closePopup,
  type = "newVariant"
}: any) => {
  //const {setCurrentVariant} = useRoutePlan();
  const [currentStep, setCurrentStep] = useState<number>(1);
  const currentStepRef = useRef(currentStep);

  const [steps, setSteps] = useState<StepItem[]>([]);
  useEffect(() => {
    const nextSteps = type === "addBP" ? stepsAddOnly : stepsCreateVariant;
    setSteps(nextSteps);
    setCurrentStep(0);
    currentStepRef.current = 0;
  }, [type]);
  useEffect(() => {
    currentStepRef.current = currentStep;
    //console.log("Current Step Updated:", currentStep);
  }, [currentStep]);
  useEffect(() => {
    let timer: NodeJS.Timeout;

    const fetchData = async () => {
      try {
        // console.log(
        //   "Polling route plan output for variant:",
        //   newAddedVariantId
        // );
        const response =
          await routePlanService.getRoutePlanOutput(newAddedVariantId);
        // console.log("Polling route plan output:", response);
        if (response) {
          const variantStatus = response.status;

          if (variantStatus === 1) {
            const currentDate = Date.now();
            const createdDate =
              response.updatedDate && response.updatedDate > 0
                ? response.updatedDate
                : response.createdDate;
            const diffInMinutes = Math.floor(
              (currentDate - createdDate) / (1000 * 60)
            );
            //console.log("Time since creation (minutes):", diffInMinutes);
            if (diffInMinutes >= 5) {
              setSteps(prev =>
                prev.map(step => ({
                  ...step,
                  status: 3 //  3 - Failed
                }))
              );
              changeVariant();
              setTimeout(() => {
                closePopup();
              }, 2000);
            }
            // Update steps based on time difference
            setSteps(prev => {
              const updatedSteps = [...prev];
              const stepIndex = currentStepRef.current;
              // console.log("Current Step Index:", stepIndex, stepIndex < 2);
              if (stepIndex <= 2) {
                //console.log(updatedSteps[stepIndex], stepIndex);
                //console.log(updatedSteps[stepIndex + 1], stepIndex + 1);

                if (updatedSteps[stepIndex]) {
                  updatedSteps[stepIndex].status = 2; // mark as completed
                  if (updatedSteps[stepIndex + 1]) {
                    updatedSteps[stepIndex + 1].status = 1; // start next
                  }
                }
              }
              //console.log("Updated Steps:", updatedSteps);
              return updatedSteps;
            });
            setCurrentStep(prev => {
              //console.log("Incrementing Step from:", prev);
              return prev + 1;
            });
          } else {
            clearInterval(timer);
            //  console.log("Polling stopped — variantStatus:", variantStatus);
            // setSteps(prev =>
            //   prev.map(step => ({
            //     ...step,
            //     status: variantStatus === 2 ? 2 : 3 // 2 - Completed, 3 - Failed
            //   }))
            // );
            setSteps(prev =>
              prev.map(step => {
                if (
                  step.label === "Finalizing Routes" ||
                  step.label === "Done"
                ) {
                  return {
                    ...step,
                    status: variantStatus === 2 ? 2 : 3 // 2 - Completed, 3 - Failed
                  };
                }
                return {...step, status: 2};
              })
            );
            changeVariant();

            if (variantStatus === 2) {
              // 4 - Failed 2 - Completed
              if (type === "newVariant") {
                setTimeout(() => {
                  setIsHistoryTab(true);
                }, 3000);
              } else {
                setTimeout(() => {
                  closePopup();
                }, 3000);
              }
            } else {
              setTimeout(() => {
                closePopup();
              }, 3000);
            }
          }
        }
      } catch (err) {
        console.error("Error fetching route plan output:", err);
      }
    };
    // Call immediately once
    // fetchData();
    timer = setInterval(fetchData, 30 * 1000);
    // Cleanup on unmount
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex flex-col items-center space-y-3">
      <div className="rounded-full bg-yellow-100 p-3">
        <Image
          src={`/icons/routePlan/yellowroute.svg`}
          alt={""}
          width={20}
          height={20}
          // className="mb-4"
        />
      </div>
      <h2 className="text-lg font-semibold text-gray-800">
        Generating Optimized Routes...
      </h2>
      <p className="text-sm text-gray-500">
        Please wait while we calculate the best paths for you.
      </p>
      <div className="mt-4 space-y-1 text-left">
        {steps.map(step => (
          <div key={step.label} className="flex items-center space-x-4">
            {/* processed */}
            {step.status === 0 ? (
              <div className="rounded-full bg-gray-200 p-2">
                <Image
                  src={`/icons/routePlan/${step.icon}.svg`}
                  alt={""}
                  width={20}
                  height={20}
                  // className="mb-4"
                />
              </div>
            ) : step.status === 1 ? (
              <div className="flex items-center justify-center rounded-full bg-white p-2">
                <Spinner size="sm" color="warning" />
              </div>
            ) : step.status === 3 ? (
              <div className="flex items-center justify-center rounded-full bg-white p-2">
                <Image
                  src={`/icons/routePlan/optimizationFaild.svg`}
                  alt={""}
                  width={20}
                  height={20}
                  // className="mb-4"
                />
              </div>
            ) : (
              step.status === 2 && (
                <div className="flex items-center justify-center rounded-full bg-green-400 p-2">
                  <Image
                    src={`/icons/routePlan/processed.svg`}
                    alt={""}
                    width={10}
                    height={10}
                    // className="mb-4"
                  />
                </div>
              )
            )}
            {/*  */}
            <span
              className={clsx(
                "text-md text-gray-700",
                step.status === 1 ? "font-extrabold" : "font-thin"
              )}
            >
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
